import { render, staticRenderFns } from "./NoviSwitch.vue?vue&type=template&id=c9d43ce0&"
import script from "./NoviSwitchVue.ts?vue&type=script&lang=ts&"
export * from "./NoviSwitchVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports